/**
 * Nur interne Pfade als Ziel nach der Anmeldung zulassen (Schutz vor Weiterleitung auf fremde Seiten).
 * Verworfen werden fremde Adressen, protokollrelative Adressen (`//host`), Rückwärts-Schrägstriche und Steuerzeichen
 * (Browser entfernen Tabulatoren und Zeilenumbrüche in Adressen, `/\t/host` würde sonst zu `//host`).
 */
export function safeNext(next: string | null): string {
  if (
    next === null ||
    !next.startsWith('/') ||
    next.startsWith('//') ||
    next.includes('\\') ||
    // eslint-disable-next-line no-control-regex
    /[\u0000-\u001f\u007f\s]/.test(next)
  ) {
    return '/';
  }
  return next;
}
